var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"h-cart__link-count",class:{'h-cart__link-count--notempty' : (this.favcount>0)}},[_vm._v(_vm._s(this.favcount))])}
var staticRenderFns = []
export { render, staticRenderFns }